import kebabCase from './kebabCase';

/**
 * Converts a string to [camel case](https://en.wikipedia.org/wiki/Camel_case).
 *
 * @example
 * camelCase('Foo Bar');
 * // => 'fooBar'
 *
 * @function camelCase
 * @param {string} str The string to convert.
 * @return {string} Returns the camel cased string.
 */
export default function camelCase(str) {
	return kebabCase(str)
		.replace(/[-_]+/g, ' ')
		.replace(/[^\w\s]/g, '')
		.replace(/ (.)/g, $1 => $1.toUpperCase())
		.replace(/ /g, '');
}
